import {easepick} from '@easepick/core';
import {DateTime} from '@easepick/datetime';
import moment from 'moment';
import {LockPlugin} from '@easepick/lock-plugin';
import dateProps from '@/mixins/shared/dateProps'


export default {
	mixins: [dateProps],


	data() {
		return {
			config: {},
			datepicker: null,
			timeout: null,
			changedByPicker: false
		}
	},
	beforeUnmount() {
		clearTimeout(this.timeout);
		this.datepicker?.destroy();
		this.datepicker = null;
	},
	watch: {
		modelValue(value) { this.setPickerDate(value); },
		min(value) { this.setMinDate(value); },
		max(value) { this.setMaxDate(value); },
	},
	methods: {
		createEasepick(config = {}, easepickPlugins = []) {
			const plugins = [
				LockPlugin,
				...easepickPlugins,
			]

			this.config = {
				element: this.$refs.input,
				css: ['/css/easepick.css', 'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.1/dist/index.css'],
				zIndex: 10,
				lang: 'nl-NL',
				readonly: false,
				plugins: plugins,
				locale: {
					nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"></path></svg>',
					previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"></path></svg>',
					cancel: 'Annuleren',
					apply: 'Toepassen'
				},
				setup: (picker) => {
					picker.on('view', (e) => this.addYearSelector(picker, e));
					picker.on('select', (e) => this.onDateSelect(e.detail.date));
				},
				LockPlugin: {
					minDate: this.getMinDate(),
					maxDate: this.getMaxDate(),
				},

				...config
			};

			this.datepicker = new easepick.create(this.config);

			let $input = $(this.$refs.input);
			$input.data('datepicker', this.datepicker);
			$input.addClass('easepick-input');

			if (this.modelValue) {
				this.setPickerDate(this.modelValue);
			}

			return this.datepicker;
		},

		changeDateByKeyboard(event) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this.changeModelValueTo(event.target.value);
			}, 500);
		},

		setPickerDate(value) {
			if (this.changedByPicker || !this.datepicker) return;

			if (!value) {
				this.datepicker.clear();
				return;
			}

			const date = moment(value).toDate();
			this.datepicker.setDate(date);
			this.datepicker.gotoDate(date);
		},
		setMinDate(value) {
			if (!this.datepicker) return;

			const newMinDate = value ? new DateTime(moment(value).toDate()) : null;
			this.datepicker.PluginManager.getInstance('LockPlugin').options.minDate = newMinDate;
			this.datepicker.renderAll();

			if (newMinDate && this.modelValue && moment(this.modelValue).isBefore(moment(value))) {
				this.changeModelValueTo(null);
			}
		},
		setMaxDate(value) {
			if (!this.datepicker) return;

			const lockPlugin = this.datepicker.PluginManager.getInstance('LockPlugin');
			lockPlugin.options.maxDate = value ? new DateTime(moment(value).toDate()) : null;

			this.datepicker.renderAll();
		},
		async onDateSelect(date) {
			let format = 'YYYY-MM-DD';
			if (this.$refs.input.type === 'datetime-local') {
				format += 'THH:mm';
			}

			this.changedByPicker = true;
			this.changeModelValueTo(date.format(format));
			await this.$nextTick();
			this.changedByPicker = false;
		},

		addYearSelector(picker, event) {
			const calendar = event.target;
			const header = calendar.querySelector('.header');
			const monthElement = header?.querySelector('.month-name');

			if (!header || header.querySelector('.year-selector') || !monthElement) {
				return;
			}

			const currentYear = new Date().getFullYear();
			const viewYear = this.extractYearFromDisplay(monthElement.textContent) || currentYear;

			const yearSelect = this.createYearSelect(viewYear, currentYear);
			yearSelect.addEventListener('change', (e) => {
				const date = new Date(e.target.value, 0, 1);
				picker.gotoDate(date);
			});

			monthElement.after(yearSelect);
		},

		extractYearFromDisplay(text) {
			const match = text.match(/\d{4}/);
			return match ? parseInt(match[0]) : null;
		},

		createYearSelect(selectedYear, currentYear) {
			const select = document.createElement('select');
			select.className = 'year-selector';
			select.style.cssText = 'margin: 0 5px; padding: 2px 5px; border: 1px solid #ddd; border-radius: 3px;';

			const startYear = currentYear - this.yearsBack;
			const endYear = currentYear + this.yearsForward;

			for (let year = startYear; year <= endYear; year++) {
				const option = new Option(year, year, false, year === selectedYear);
				select.appendChild(option);
			}

			return select;
		},
		getMinDate() {
			return this.min ? new Date(this.min) : null;
		},

		getMaxDate() {
			return this.max ? new Date(this.max) : null;
		}

	}
}